import { ForgerockAccountType, jwtDecode } from '@dtvgo/utils';
import { ErrorCode } from '@dtvgo/error';
import { AuthorizerErrorCode } from '../types.js';

function playback(backendAxiosInstance) {
  async function getTokenAuthorizer({
    delay = 0,
    mobileNetwork = false,
    isLive,
    contentId
  }) {
    return backendAxiosInstance.post("/entitlement/v3/playback/token/authorizer", {
      delay,
      mobileNetwork,
      isLive,
      contentId
    }, {
      getErrorCode: getAuthorizerErrorCode
    });
  }
  async function refreshTokenAuthorizer({ delay = 0, mobileNetwork, refreshToken }) {
    return backendAxiosInstance.post("/entitlement/v3/playback/token/refresh", {
      delay,
      mobileNetwork,
      refreshToken
    }, {
      getErrorCode: getAuthorizerErrorCode
    });
  }
  return {
    getTokenAuthorizer,
    refreshTokenAuthorizer
  };
}
const NOT_IN_PACKAGE_BY_BUSSINESS_UNIT_ERROR_CODES = {
  [ForgerockAccountType.SSLA_OTT]: ErrorCode.NOT_IN_PACKAGE_OTT,
  [ForgerockAccountType.BR_OTT]: ErrorCode.NOT_IN_PACKAGE_OTT,
  [ForgerockAccountType.LATAM_OTT]: ErrorCode.NOT_IN_PACKAGE_DTH,
  [ForgerockAccountType.LATAM_DTH]: ErrorCode.NOT_IN_PACKAGE_DTH,
  [ForgerockAccountType.SSLA_DTH]: ErrorCode.NOT_IN_PACKAGE_DTH,
  [ForgerockAccountType.SKY_DTH]: ErrorCode.NOT_IN_PACKAGE_DTH,
  [ForgerockAccountType.MSO_DTH]: ErrorCode.NOT_IN_PACKAGE_B2B2C
};
const AuthorizerErrorCodeToVrioOttErrorCode = {
  [AuthorizerErrorCode.GOOGLE_PLAY_NOT_IN_PACKAGE]: ErrorCode.NOT_IN_PACKAGE_GOOGLE_IAP_OTT,
  [AuthorizerErrorCode.NOT_AT_REGION]: ErrorCode.NOT_IN_REGION,
  [AuthorizerErrorCode.CONCURRENCY_PER_USER]: ErrorCode.AUTHORIZER_CONCURRENT_USER_LIMIT,
  [AuthorizerErrorCode.CONCURRENCY_PER_CHANNEL]: ErrorCode.AUTHORIZER_CONCURRENT_CHANNEL_LIMIT,
  [AuthorizerErrorCode.CONCURRENCY_PER_PROVIDER]: ErrorCode.AUTHORIZER_CONCURRENT_PROVIDER_LIMIT,
  [AuthorizerErrorCode.CONCURRENCY_PER_DEVICE]: ErrorCode.AUTHORIZER_CONCURRENT_DEVICE_LIMIT,
  [AuthorizerErrorCode.NOT_VALID_FORGEROCK_TOKEN]: ErrorCode.AUTHORIZER_NOT_VALID_CUSTOMER_TOKEN,
  [AuthorizerErrorCode.NOT_VALID_CUSTOMER_TOKEN]: ErrorCode.AUTHORIZER_NOT_VALID_CUSTOMER_TOKEN,
  [AuthorizerErrorCode.NOT_VALID_ASSET_TOKEN]: ErrorCode.AUTHORIZER_NOT_VALID_ASSET_TOKEN,
  [AuthorizerErrorCode.NOT_VALID_REFRESH_TOKEN]: ErrorCode.AUTHORIZER_NOT_VALID_REFRESH_TOKEN,
  [AuthorizerErrorCode.NOT_VALID_REFRESH_TOKEN_2]: ErrorCode.AUTHORIZER_NOT_VALID_REFRESH_TOKEN
};
function getAuthorizerErrorCode(error) {
  if (!error.response)
    return void 0;
  const data = error.response.data;
  if (!data?.details)
    return ErrorCode.AUTHORIZER_OTHERS;
  if (data.details === AuthorizerErrorCode.NOT_IN_PACKAGE) {
    const [, sessionToken] = error.config?.headers.getAuthorization(/Bearer (.*)/) || [];
    const { businessUnit } = jwtDecode(sessionToken);
    return NOT_IN_PACKAGE_BY_BUSSINESS_UNIT_ERROR_CODES[businessUnit];
  }
  return AuthorizerErrorCodeToVrioOttErrorCode[data.details] || ErrorCode.AUTHORIZER_OTHERS;
}

export { playback as default };
//# sourceMappingURL=playback.js.map
